module.exports = __webpack_public_path__ + "img/supportsm__study-videos.ca7fd8da.svg";